import React, { useState } from 'react';
import Slider from "react-slick";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

const accordionData = [
   
{
id:1,
title:"Process Chillers",
content:"Efficient, reliable process chillers engineered to maintain precise temperature control in critical industrial operations. Designed for continuous duty and optimized energy performance, our systems ensure consistent process quality and reduced downtime."
},
{
id:2,
title:"Instant Milk Chiller",
content:"Rapid milk chilling solutions preserve freshness and flavor right at the source. These systems instantly bring milk temperature down, inhibiting bacterial growth and ensuring superior hygiene for dairy processing operations."
},
{
id:3,
title:"Refrigerated Sea Water (RSW) System",
content:"High-efficiency RSW systems provide rapid onboard chilling of seafood to maintain quality from catch to port. Built for durability and low power consumption, they deliver precise temperature control in demanding marine environments."
},
{
id:4,
title:"Boil-Off Gas Condensing System",
content:"Efficiently reclaim and condense boil-off gas from cryogenic storage or transport operations. Our systems minimize product loss, reduce emissions, and enhance safety in LNG and industrial gas handling."
},
{
id:5,
title:"Gas Liquefaction System",
content:"Advanced liquefaction technology enabling efficient conversion of gases into liquid form for storage or transport. Designed for high reliability and low energy use, supporting natural gas and specialty gas processing industries."
},
{
id:6,
title:"Turbine Inlet Air Cooling System",
content:"Boost power output and efficiency with our turbine inlet air cooling systems. By reducing inlet air temperature, these systems enhance turbine performance, especially in hot climates, while ensuring stable operation."
},
{
id:7,
title:"CO₂ Atmospheric Vaporizer",
content:"Robust CO₂ vaporizers that ensure safe, efficient gas-phase conversion under varying environmental conditions. Designed for continuous industrial duty with low maintenance and high heat transfer performance."
}
]


function Coolingandchilling() {
    useGaspAnimations()

 const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };


     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      }



    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
 
{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Cooling & Chilling Systems</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Cooling & Chilling Systems</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
            <ProductFilter/>
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeLeft">
                                {/* <Slider {...settings}>
                                      
                            </Slider> */}
                             <img src="assets/images/OurProducts/Cooling-&-Chilling-Systems.webp" alt="Awesome Image"/>
                     
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                
                                  <div className="title bdFadeUp sec-title">
                                    
                                    <h1 className='title-anim'><span>Process Chillers and Coolers</span></h1>
                                </div>
                                <div className="text bdFadeRight">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                      Indus Refrigeration delivers a comprehensive portfolio of high-performance cooling and chilling systems engineered to meet the diverse demands of industrial and commercial applications.
                                    </p>
                                    <p>
                                         Our solutions are built for reliable operation, precise temperature control, and energy efficiency, ensuring optimal process stability, product quality, and reduced operational costs. From maintaining critical temperatures in food processing and chemical industries to specialized cooling for gas and marine applications, our systems are designed for durability and longevity. We provide tailored engineering and support to meet the unique requirements of each project, ensuring efficient and sustainable cooling solutions.
                                    </p>
                                       <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                </div>
                              
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content">
                        <div className="col-md-7 bdFadeRight">
                            <div className="text-holder">
                                <div className="title">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul>
                                       <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Process Chillers</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Instant Milk Chiller</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Refrigerated Sea Water </li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Boil Off Gas Condensing system</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Gas Liquification</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Turbine Inlet Air cooling system</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>CO2 Atmospheric  Vapouriser,</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-5 bdFadeRight">
                              <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider>
                        </div> */}
                    </div>
                    {/* <!--End middle content--> */}
                    {/* <!--Start bottom content--> */}
                    <div className="row bottom-content">
                        <div className="col-md-12 bdFadeRight">
                            <div className="title">
                                    <h2>Sub-category Descriptions</h2>
                                </div>
                            <div className="accordion-box">
                                {accordionData.map(({ id, title, content }) => (
                                <>
                                 {/* <!--Start single accordion box--> */}
                                <div className="accordion accordion-block" key={id}>
                                    <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                    {openSections[id] && (
                                    <div className="accord-content collapsed">
                                        <p>
                                        {content}
                                        </p>
                                    </div>
                                    )}
                                </div>
                                 {/* <!--End single accordion box-->  */}
                                </>
                                ))}
                        </div>
                    </div>
                     </div> 
                    {/* <!--End bottom content--> */}
                    {/* <!--Start Consultation form--> */}
                 
                    {/* <!--End Consultation form--> */}
                </div>
            </div>
           
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}
     <MakeAppoinment/>
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Coolingandchilling;
